import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import { compose } from 'recompose'

import Body from 'components/typography/body2/index'
import UserSelection from './UserSelection'

import styles from './styles.scss'

const UserInput = ({label, ...rest}) => {
  return (
    <Flex
      align='center'
      auto
      styleName='userInputContainer'
    >
      <div styleName='userInputHeader'>
        <Body>{label}</Body>
      </div>
      <div styleName='userInput'>
        <UserSelection {...rest}/>
      </div>
    </Flex>
  )
}

const withStyle = CSSModules(styles)

export default compose(
  withStyle
)(UserInput)

